export default {
	active_campaigns: "Active Campaigns",
	begin_date: "Start Date",
	campaign: "Campaign",
	end_date: "End Date",
	learn_more_about_the_campaign_by_clicking: "Learn more about the campaign by clicking",
	no_campaigns_found: "No campaigns found",
	previous_campaigns: "Previous Campaigns",
	view_campaign: "View Campaign"
}